@if (isVisible) {
  <div
    class="alert alert-dismissable alert-{{ type }} py-3"
    role="alert"
    id="{{ componentId }}"
    [attr.aria-labelledby]="componentId + '-header'"
    tabindex="-1"
  >
    <svg aria-hidden="true">
      <use xlink:href="#alert"></use>
    </svg>
    <h3 [ngClass]="header.length === 0 ? 'visuallyhidden' : ''" id="{{ componentId }}-header" class="mb-2">
      @if (header.length > 0) {
        {{ header }}
      }
      @if (header.length === 0) {
        {{ 'error_header' | translate }}
      }
    </h3>
    <p class="alert-message">{{ message }}</p>
    @if (technicalDetails.length > 0) {
      <div class="technical-details">
        <ul id="{{ componentId }}-errorDetailsList" class="mt-1">
          @for (technicalMessage of technicalDetails; track technicalMessage) {
            <li [innerHTML]="technicalMessage"></li>
          }
        </ul>
        @if (pageScreenshot !== null) {
          <div class="row">
            <div class="col-md-12">
              <h4>{{ 'error_page_screenshot' | translate }}</h4>
              <img [attr.src]="pageScreenshot.screenshot" alt="{{ 'scan_error_page_screenshot' | translate }}" />
            </div>
            <div class="col-md-12">
              <h4>{{ 'error_page_header' | translate }}</h4>
              <pre>{{ getHeaderData() }}</pre>
            </div>
          </div>
        }
      </div>
    }
    <button type="button" class="close-alert" (click)="remove()">
      <span class="visuallyhidden">{{ 'close_alert' | translate }}</span>
      &times;
    </button>
  </div>
}
